import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/docrates-icon-imaging.svg'


const _withScopeId = n => (_pushScopeId("data-v-3ecc90d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "div-category-selectables-base" }
const _hoisted_2 = { class: "div-category-selectables-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "div-category-selectables-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "img-category-selectables-content",
    src: _imports_0
  })
], -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "div-category-selectables-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_category_service_card = _resolveComponent("category-service-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h2", {
        id: "category-selectables-h2",
        innerHTML: 
          _ctx.store.getters.translate(
            'category-services-appointment-imaging-heading'
          )
        
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_category_service_card, {
        onSelected: _ctx.serviceSelectedInComponent,
        categoryServiceType: "mammography",
        heading: 
          _ctx.store.getters.translate('category-service-card-mammography-heading')
        ,
        "text-1": 
          _ctx.store.getters.translate('category-service-card-mammography-text-1')
        ,
        "text-1link": 
          _ctx.store.getters.translate(
            'category-service-card-mammography-text-1-link'
          )
        ,
        "text-1b": 
          _ctx.store.getters.translate('category-service-card-mammography-text-1b')
        
      }, null, 8, ["onSelected", "heading", "text-1", "text-1link", "text-1b"]),
      _createVNode(_component_category_service_card, {
        onSelected: _ctx.serviceSelectedInComponent,
        categoryServiceType: "ct-scan",
        heading: 
          _ctx.store.getters.translate('category-service-card-ct-scan-heading')
        ,
        "text-bold": 
          _ctx.store.getters.translate('category-service-card-ct-scan-text-bold')
        ,
        "text-1": 
          _ctx.store.getters.translate('category-service-card-ct-scan-text-1')
        ,
        "text-2": 
          _ctx.store.getters.translate('category-service-card-ct-scan-text-2')
        
      }, null, 8, ["onSelected", "heading", "text-bold", "text-1", "text-2"]),
      _createVNode(_component_category_service_card, {
        onSelected: _ctx.serviceSelectedInComponent,
        categoryServiceType: "mri-scan",
        heading: 
          _ctx.store.getters.translate('category-service-card-mri-scan-heading')
        ,
        "text-bold": 
          _ctx.store.getters.translate('category-service-card-mri-scan-text-bold')
        ,
        "text-1": 
          _ctx.store.getters.translate('category-service-card-mri-scan-text-1')
        ,
        "text-2": 
          _ctx.store.getters.translate('category-service-card-mri-scan-text-2')
        ,
        "text-3": 
          _ctx.store.getters.translate('category-service-card-mri-scan-text-3')
        
      }, null, 8, ["onSelected", "heading", "text-bold", "text-1", "text-2", "text-3"])
    ])
  ]))
}